import { useCallback, useState } from "react";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Popup from "../../../components/Popup";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import Service from "../../../assets/img/SolutionsIcons/AgilysysService.svg";
import { Header } from "../../../components/Header";

const ServiceFPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const [showVideo, setShowVideo] = useState<boolean>(false);
    const [showVideo2, setShowVideo2] = useState<boolean>(false);
    return(
        <div className="page splash serviceFPage">
            <div className="page-title"><img src={Service} alt="" /></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                Service on time, every time, without over-stressing staff.
Real-time texts between guests and service staff simplifies
timing, tracking and satisfying requests. Assign and route
service requests to a mobile-equipped team to save time
and balance workloads. Minimize training time and protect
brand standards through guided task instructions.{'\n\n'}
                </div>
                <div className="std-text">
                The solution offers an enhanced guest experience through
2-way SMS communications with staff, as well as support for
guided hotel room cleaning and inspections, and preventive
maintenance.
                </div>
            </div>
            <div className="video-buttons">
                <div className="play-video" onClick={()=>{
                    _logEvent('click', "Solutions - Service", "Play Staff Video");
                    addFlow("Play Staff Video");
                    setShowVideo(true)}}>
                    <PlayTriangle />
                    Play Staff Video
                </div>
                <div className="play-video guest" onClick={()=>{
                    _logEvent('click', "Solutions - Service", "Play Guest Video");
                    addFlow("Play Guest Video");
                    setShowVideo2(true)}}>
                    <PlayTriangle />
                    Play Guest Video
                </div>
            </div>
            <img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/Service1.png"} alt="" />
            <img className="img-2" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/Service2.png"} alt="" />
            <img className="img-3" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/Service3.png"} alt="" />
            <Popup showPopup={showVideo} setShowPopup={()=>setShowVideo(false)} disableOffClick={true}>
                <>{showVideo && <video 
                autoPlay
                controls
                src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveServiceStaff.mp4"} />}</>
            </Popup>
            <Popup showPopup={showVideo2} setShowPopup={()=>setShowVideo2(false)} disableOffClick={true}>
                <>{showVideo2 && <video 
                autoPlay
                controls
                src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveServiceGuest2.mp4"} />}</>
            </Popup>
        </div>
    )
}

export default ServiceFPage;